var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("应用跳转页面")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.gotoLogin}},[_vm._v("跳转登录页")]),_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.gotoSub02}},[_vm._v("跳转sub02")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }